import {
    // TOKEN_ABI,
    // USDT_Token_ADDRESS,
    Contract_Address,
    Contract_ABI,
  } from "./config";
  import {
    readContract,
    writeContract,
    // fetchBalance,
  } from "@wagmi/core";
  
//   const getTokenAddress = {
//     address: USDT_Token_ADDRESS,
//     abi: TOKEN_ABI,
//   };
  const getAddress = {
    address: Contract_Address,
    abi: Contract_ABI,
  };

  export async function getOwnerAddress() {
    try {
      const data = await readContract({
        ...getAddress,
        functionName: "owner",
      });
      console.log(data,"gfdgfjdfjk");
     return data;
    } catch (error) {
      console.log(error);
    }
  }
  export async function setRewardWallets(wallet1,wallet2) {
    console.log(wallet1,wallet2);
    try {
      const data = await writeContract({
        ...getAddress,
        functionName: "addWalletsForOwnerReward",
        args:[[wallet1,wallet2]]
        // value:[wallet1,wallet2]
      });
      console.log(data,"gfdgfjdfjk");
     return data;
    } catch (error) {
      console.log(error);
    }
  }
export async function currentIndexGlobalQ(packId, qId) {
    try {
      const data = await readContract({
        ...getAddress,
        functionName: "currentIndexGlobalQ",
        args: [packId, qId],
      });
  
      return data;
    } catch (error) {
      console.log(error);
    }
  }